// Components
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';

import Dropdown from 'app/components/Dropdown';
import SearchableDropdown from 'app/components/SearchableDropdown';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import Button from 'app/components/button';

// API

// Constants

import Toggle from 'react-toggle';
import TextArea from 'app/components/Textarea';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import TemplateForm from './TemplateForm';
import useCreateOffer from './useCreateOffer';
import { commonMaxDate, commonMinDate } from 'app/utils/Parsers';

const CreateOffer = () => {
  const {
    handleMallChange,
    templateList,
    storeList,
    storeId,
    mallList,
    handleChange,
    values,
    error,
    handleCreateOffer,
    pageLoading,
    setChange,
    navigate,
    isDisabled,
    setisDisabled,
    templatehideonEdit,
    isExpired,
  } = useCreateOffer();
  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${storeId ? ' Edit Offer  ' : 'Create Offer'}`}
          goTo={APP_CONSTANTS.OFFER_DEALS}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <Dropdown
              id={'mallId'}
              label='Mall name*'
              name='mallId'
              options={mallList}
              placeholder='Select Mall '
              value={values.mallId}
              handleChange={handleMallChange}
              errorText={error?.mallId}
            />
          </div>
          <div className='wd-50'>
            <SearchableDropdown
              id='storeId'
              label='Store name*'
              name='storeId'
              options={storeList}
              placeholder='Search store...'
              value={values.storeId}
              handleChange={handleChange}
              errorText={error?.storeId}
            />
          </div>

          <div className='wd-100'>
            <Dropdown
              id='templateId'
              label='Template*'
              name='templateId'
              options={templateList}
              placeholder='Select Template'
              value={values.templateId}
              handleChange={handleChange}
              errorText={error?.templateId}
            />
          </div>

          {templatehideonEdit && (
            <div className='wd-100 shop-type'>
              <TemplateForm
                templateList={templateList}
                values={values}
                error={error}
                handleChange={handleChange}
                isDisabled={isDisabled}
              />
            </div>
          )}

          <div className='wd-100'>
            <NewInput
              label='Title*'
              id='title'
              type='text'
              placeholder='Title'
              name='title'
              value={values?.title}
              onChange={(e) => {
                setisDisabled(true);
                handleChange(e);
              }}
              errorText={error?.title}
            />
          </div>

          <div className='wd-100'>
            <TextArea
              label='Description*'
              id='description'
              type='text'
              placeholder='Description'
              name='description'
              value={values?.description}
              onChange={handleChange}
              errorText={error?.description}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Start Time*'
              id='startDate'
              placeholder='DD-YY-MMMM'
              name='startDate'
              format='DD-MM-YYYY'
              type={'date'}
              min={commonMinDate()}
              max={commonMaxDate()}
              value={values?.startDate}
              onChange={handleChange}
              errorText={error?.startDate}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='End Date*'
              name='endDate'
              id='endDate'
              placeholder={'End Date'}
              min={values.startDate ? values.startDate : commonMinDate()}
              max={commonMaxDate()}
              value={values?.endDate}
              type={'date'}
              onChange={handleChange}
              errorText={error?.endDate}
            />
          </div>
          <div className='d-block wd-100'>
            <label className='me-2 d-inline-block tooltip-on-hover'>
              Status*
            </label>
            <label className='d-inline-block mt-2'>
              <div className='d-inline-flex align-items-center'>
                <div className='d-inline-flex text-danger'>OFF</div>
                <div className='d-inline-flex mx-2'>
                  <Toggle
                    checked={!!values.status && !isExpired}
                    disabled={isExpired}
                    icons={false}
                    onChange={() => {
                      // An expired offer cannot be activated.
                      if (isExpired) return;
                      setChange('status', !values.status);
                    }}
                  />
                </div>
                <div className='d-inline-flex text-green'>ON</div>
              </div>
            </label>
          </div>
        </div>

        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateOffer}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateOffer;
